import { useEffect, useState } from 'react';
import { FormattedMessage } from 'react-intl';
import { PageView } from '../../../../../../models/analytics';
import { useAnalytics } from '../../../../../../core/Analytics/AnalyticsProvider';
import { Header } from '../../../../../organisms/Header/Header';
import { ContentBody } from '../../../../../atoms/ContentBody/ContentBody';
import { StyledError } from '../../SubmitCredentialsScreen.styles';
import { messages } from '../../../../SubmitCredentials/messages';
import { ApplicationUnverifiedLabel } from '../../../../../molecules/ApplicationUnverifiedLabel/ApplicationUnverifiedLabel';
import { Footer } from '../../../../../atoms/Footer/Footer';
import { LoadingSpinner } from '../../../../../atoms/LoadingSpinner/LoadingSpinner';
import { Button } from '../../../../../atoms/Button/Button';
import { ProviderBanner } from '../../../../SubmitCredentials/molecules/ProviderBanner/ProviderBanner';
import {
  createSubmitCredentialsScreen,
  SubmitCredentialsScreenCreatorProps,
} from '../../components/SubmitCredentialsScreenCreator/SubmitCredentialsScreenCreator';
import { SubmitCredentialsBase } from '../../components/SubmitCredentialsBase/SubmitCredentialsBase';
import { NoFieldsForm } from '../../components/NoFieldsForm/NoFieldsForm';

export const getNoFieldsHeader: SubmitCredentialsScreenCreatorProps['getHeader'] = (
  onBack,
  HeaderBase = Header
) => {
  return ({ provider, ...headerProps }) => (
    <HeaderBase addBottomMargin {...headerProps} onBack={onBack} />
  );
};

export const getNoFieldsForm: SubmitCredentialsScreenCreatorProps['getForm'] = (onSubmit) => {
  return ({ credentialsError, userHintId, isClientVerified, isCredentialsLoading, provider }) => {
    const { tinklinkAnalytics } = useAnalytics();
    const [isButtonDisabled, setIsButtonDisabled] = useState<boolean>(true);

    useEffect(() => {
      tinklinkAnalytics.sendViewEvent({
        view: PageView.NO_FIELDS_FORM_SCREEN,
      });
    }, [tinklinkAnalytics]);

    return (
      <ContentBody>
        {credentialsError && <StyledError>{credentialsError}</StyledError>}
        <NoFieldsForm
          setButtonDisabled={setIsButtonDisabled}
          onSubmit={() => onSubmit({ fields: {} })}
        >
          <ApplicationUnverifiedLabel isVerified={Boolean(isClientVerified)} />
          <ProviderBanner provider={provider} userHintId={userHintId} />
          <Footer stickToBottom>
            {isCredentialsLoading ? (
              <LoadingSpinner />
            ) : (
              <Button
                disabled={isButtonDisabled}
                type="submit"
                color="primary"
                variant="contained"
                data-testid="submit-credentials-button"
                data-test="submitCredentialsButton"
              >
                <FormattedMessage {...messages.continue} />
              </Button>
            )}
          </Footer>
        </NoFieldsForm>
      </ContentBody>
    );
  };
};

export const NoFieldsScreen = createSubmitCredentialsScreen({
  SubmitCredentialsBase,
  getHeader: getNoFieldsHeader,
  getForm: getNoFieldsForm,
});
